import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useFormValidationState as $6FfNf$useFormValidationState } from "@react-stately/form";
import { useOverlayTriggerState as $6FfNf$useOverlayTriggerState } from "@react-stately/overlays";
import { useSingleSelectListState as $6FfNf$useSingleSelectListState } from "@react-stately/list";
import { useState as $6FfNf$useState } from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $2bc3a590c5373a4e$export$5159ec8b34d4ec12(props) {
  var triggerState = (0, $6FfNf$useOverlayTriggerState)(props);

  var _ref = (0, $6FfNf$useState)(null),
      _ref2 = _slicedToArray(_ref, 2),
      focusStrategy = _ref2[0],
      setFocusStrategy = _ref2[1];

  var listState = (0, $6FfNf$useSingleSelectListState)(_objectSpread(_objectSpread({}, props), {}, {
    onSelectionChange: function onSelectionChange(key) {
      if (props.onSelectionChange != null) props.onSelectionChange(key);
      triggerState.close();
      validationState.commitValidation();
    }
  }));
  var validationState = (0, $6FfNf$useFormValidationState)(_objectSpread(_objectSpread({}, props), {}, {
    value: listState.selectedKey
  }));

  var _ref3 = (0, $6FfNf$useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isFocused = _ref4[0],
      setFocused = _ref4[1];

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, validationState), listState), triggerState), {}, {
    focusStrategy: focusStrategy,
    open: function open() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      // Don't open if the collection is empty.
      if (listState.collection.size !== 0) {
        setFocusStrategy(focusStrategy);
        triggerState.open();
      }
    },
    toggle: function toggle() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (listState.collection.size !== 0) {
        setFocusStrategy(focusStrategy);
        triggerState.toggle();
      }
    },
    isFocused: isFocused,
    setFocused: setFocused
  });
}

export { $2bc3a590c5373a4e$export$5159ec8b34d4ec12 as useSelectState };